import React from "react";
import { Link } from "react-router-dom";
import { SealCheck, Lightning } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";
import { CATEGORY_META } from "@/data/categories";
import { priceLabel } from "@/lib/format";
import { FoundingBadge } from "@/components/FoundingBadge";
import { RatingBadge } from "@/components/RatingStars";
import { ProviderAvatar } from "@/components/AvatarUpload";

export const ListingCard = ({ listing }) => {
  const { t, tc } = useLang();
  const meta = CATEGORY_META[listing.category] || {};
  const Icon = meta.icon;
  const price = priceLabel(listing, t);

  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="card-list hover-lift flex min-w-0 items-start gap-3.5 overflow-hidden p-3.5"
    >
      <span className="relative shrink-0">
        <ProviderAvatar
          name={listing.provider_name}
          src={listing.provider_avatar ? `${process.env.REACT_APP_BACKEND_URL}${listing.provider_avatar}` : null}
          size={48}
        />
        {listing.provider_verified && (
          <SealCheck size={14} weight="fill" color="#9184d9" className="absolute -bottom-0.5 -right-0.5" />
        )}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <h3 className="truncate text-[15px] font-medium text-ppc-text">{listing.title}</h3>
          {(listing.is_business || listing.provider_verified) && (
            <SealCheck size={15} weight="fill" color="#9184d9" className="shrink-0" />
          )}
        </div>
        <p className="mt-0.5 flex items-center gap-1 truncate text-[12.5px]" style={{ color: "rgba(233,233,237,0.5)" }}>
          {Icon && <Icon className="h-3 w-3 shrink-0" />}
          <span className="truncate">{tc(listing.category)} · {listing.city}, {listing.country}</span>
        </p>
        {listing.rating_count > 0 && <RatingBadge avg={listing.rating} count={listing.rating_count} className="mt-1" />}
        {listing.founding_member ? (
          <FoundingBadge fm={listing.founding_member} className="mt-1.5" />
        ) : (
          <p className="mt-1.5 flex min-w-0 items-center gap-1 text-[12px]" style={{ color: "rgba(233,233,237,0.62)" }}>
            <Lightning size={13} weight="fill" color="#9184d9" />
            <span className="truncate">{listing.description}</span>
          </p>
        )}
      </div>
      <div className="flex shrink-0 flex-col items-end justify-between self-stretch">
        <p className="text-[14px] font-medium text-ppc-text">
          {price.main}
          <span className="ml-0.5 text-[11px] text-ppc-muted">{price.unit}</span>
        </p>
        <span className="text-[11px] text-ppc-muted">{t("from")}</span>
      </div>
    </Link>
  );
};
